import { hasRoleAdmin } from 'common/utility/userRoles';

import { SR_API_ACTION_UTILITY_ANNOUNCEMENT_TRACK_DISMISS } from 'api/utilityActionTypes';

export default async function trackDismiss(
  { state, utilityApiClient },
  { utilityPartnerId, type },
) {
  const utilityUser = state.get('utilityUser');
  if (!utilityUser || hasRoleAdmin(utilityUser.roles || [])) {
    return;
  }

  return utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_ANNOUNCEMENT_TRACK_DISMISS,
    state: state,
    payload: {
      utilityPartnerId,
      utilityUserId: utilityUser.id,
      type,
    },
  });
}
